import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import WalletList from "../components/wallet/wallet-list/walletList";
import WalletCash from "../components/wallet/cash-wallet/cash/cash";
import WalletFinal from "../components/wallet/cash-wallet/final/final";

export const walletRoutes = [
	<Route
		key="wallet-list"
		path={_adr.Root + _adr.Wallet.Index + _adr.Wallet.WalletList}
		element={<ProtectedRoute role={Roles.Dealer_Wallet_Management} element={WalletList} />}
	/>,
	<Route
		key="wallet-cash"
		path={_adr.Root + _adr.Wallet.Index + _adr.Wallet.Withdraw.Index + _adr.Wallet.Withdraw.Change}
		element={<ProtectedRoute role={Roles.Dealer_Wallet_Management} element={WalletCash} />}
	/>,
	<Route
		key="wallet-final"
		path={_adr.Root + _adr.Wallet.Index + _adr.Wallet.Withdraw.Index + _adr.Wallet.Withdraw.Final}
		element={<ProtectedRoute role={Roles.Dealer_Wallet_Management} element={WalletFinal} />}
	/>,
];
